'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var img = "data:image/svg+xml,%3csvg viewBox='0 0 93 93' xmlns='http://www.w3.org/2000/svg' fill-rule='evenodd' clip-rule='evenodd' stroke-linejoin='round' stroke-miterlimit='2'%3e%3cpath d='M62.085 90.319A46.342 46.342 0 0146.5 93C20.836 93 0 72.164 0 46.5S20.836 0 46.5 0 93 20.836 93 46.5c0 5.466-.945 10.714-2.681 15.585A19.925 19.925 0 0077 57c-11.038 0-20 8.962-20 20 0 5.114 1.924 9.782 5.085 13.319z'/%3e%3c/svg%3e";
exports["default"] = img;